import React from "react";
import TagManager from "react-gtm-module";

export function useGoogleTagManager(tagManagerId?: string) {
  React.useEffect(() => {
    if (tagManagerId) {
      TagManager.initialize({
        gtmId: tagManagerId
      });
    }
  }, [tagManagerId]);

  return null;
}
export function useLoadThirdPartyScripts() {
  // 3rd party scripts to load here
}

export function LoadThirdPartyScripts() {
  useLoadThirdPartyScripts();
  return null;
}
